import { Alert, Button, Card, ListGroup } from "react-bootstrap";
import { useContext } from "react";
import { SoknaderContext } from "./contexts/SoknaderContext";
import moment from "moment";
import { SoknadClass } from "./models/SoknadClass";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";

function Soknader() {
    const { soknader, soknaderIsLoading } = useContext(SoknaderContext);
    const navigate = useNavigate();

    const readOnlyStatuses = [2, 3, 6, 7, 8, 9]

    //Reset soknad state
    //setSoknad(null);

    return (<>
        <h3>
            Oversikt over dine søknader
        </h3>
        <Alert variant="info">
            De avsatte midlene er nå fordelt, og det er derfor dessverre ikke lenger mulig å søke om refusjon fra denne ordningen.
        </Alert>
        <hr />
        <ListGroup>
            {soknaderIsLoading ? <p>Henter søknader...</p> : soknader.length === 0 ?
                <p>Du har ingen søknader registrert. Det er ikke lenger mulig å registrere nye søknader.</p> : soknader.map((x: SoknadClass) => {
                        return (<ListGroup.Item key={x.id}>
                            <Card className={"col-md-12"}>
                                <Card.Body>
                                    <Card.Title>
                                        Søknad nr: {x.id} - Status: {x.status?.name}


                                    </Card.Title>
                                    <Card.Subtitle>Mottatt: {moment(x.registered).format("DD.MM.YYYY")}</Card.Subtitle>
                                    <hr />
                                    <Button className={"m-1"}
                                        onClick={() => navigate("/soknader/" + x.id)}> <FontAwesomeIcon
                                            icon={faEye} />Vis søknad</Button>
                                    {

                                        !readOnlyStatuses.includes(x.statusId ?? 0) ?
                                            <Button className={"m-1"} onClick={() => navigate("/soknader/" + x.id + "/edit")}>
                                                <FontAwesomeIcon
                                                    icon={faEdit} />Rediger søknad</Button> :
                                            null

                                    }
                                    <Card.Text className={"mt-2"}
                                        style={{ whiteSpace: "pre-wrap" }}>{x.applicationDescription}</Card.Text>
                                </Card.Body>
                            </Card>
                        </ListGroup.Item>)
                    })}
        </ListGroup>
    </>)
}

export default Soknader;